module.exports = __webpack_public_path__ + "static/nra-logo-43da0c97b603879b965fd3156cbb6dac.svg";